import React from 'react';

/**
 * Honest announcement bar: no fake timers, counters or prices.
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="306tihia3ka0w">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2ve0ewxqd77qe">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2rd86g6pbh6v6">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-300" data-id="element-59" data-mp="2mf6lfg8byxh2" />
        </span>
        <span className="font-semibold text-stone-50" data-id="element-60" data-mp="2heiyb5n830s4">Introduktionstilbud</span>
        <span className="text-stone-50/80" data-id="element-61" data-mp="2cffsvk3bysjm">
          · Engangsbetaling<span className="hidden sm:inline" data-id="element-62" data-mp="2ci0t64nzd0f9"> · 7 dages tilfredshedsgaranti</span>
        </span>
      </div>
    </div>;
}